import React, { useState } from "react";
import axios from "axios";
import Spacer from "./component/Spacer";
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Card,
  Typography,
  GridList,
  GridListTile,
  GridListTileBar,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
  Modal,
} from "@material-ui/core/";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import logo from "./images/logo.png";
import TrumpetTitle from "./component/TrumpeTitle";

import fjalemania from "./images/fjalemania.jpg";
import fjaustria from "./images/fjaustria.jpg";
import fjfinlandia from "./images/fjfinlandia.jpg";
import fjfrancia from "./images/fjfrancia.jpg";
import fjirlanda from "./images/fjirlanda.jpg";
import fjitalia from "./images/fjitalia.jpg";
import fjpolonia from "./images/fjpolonia.jpg";
import fjsuiza from "./images/fjsuiza.jpg";

import countries from "./helpers/countries";

const hostEmail = "https://musihall-services.bakers.dev/v1/notification/send";
const tileData = [
  {
    img: fjpolonia,
    title: "Polonia",
    author: "02 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjirlanda,
    title: "Irlanda",
    author: "02 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjalemania,
    title: "Alemania",
    author: "03 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjfinlandia,
    title: "Finlandia",
    author: "03 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjsuiza,
    title: "Suiza",
    author: "09 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjaustria,
    title: "Austria",
    author: "09 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjfrancia,
    title: "Francia",
    author: "10 de oct. 19:30",
    cols: 1,
  },
  {
    img: fjitalia,
    title: "Italia",
    author: "10 de oct. 19:30",
    cols: 1,
  },
];
const darkBlue = "#363c45";
const lightGreen = "#52dfc4";
const lightGray = "#eeeeee";
const theme = createMuiTheme({
  palette: {
    primary: {
      main: lightGreen,
    },
    secondary: {
      main: lightGreen,
    },
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(2),
      color: lightGray,
      backgroundColor: darkBlue,
    },
    "& .MuiOutlinedInput-root": {
      //color: lightGreen,
      "&:hover fieldset": {
        color: lightGray,
      },
      "& .MuiInputBase-input::placeholder": {
        color: lightGray,
      },
      "& .MuiInputBase-input": {
        color: lightGray,
      },
      "& .MuiTypography-colorTextSecondary": {
        color: lightGray,
        fontWeight: 500,
      },
      "& .MuiTypography-body1": {
        fontFamily: "Oswald",
        fontWeight: 500,
      },
    },
  },
  "trumpet-left": {
    fill: lightGray,
    transform: [{ rotate: "45deg" }],
  },
  logo: {
    justifyContent: "center",
  },
  title: {
    color: lightGreen,
    fontWeight: "500",
    fontFamily: "Oswald",
  },
  titleBar: {
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0) 100%)",
  },
  marginElements: {
    margin: theme.spacing(2),
  },
  "font-size": {
    color: lightGray,
    fontWeight: "500",
    fontFamily: "Oswald",
  },
  selectEmpty: {
    margin: theme.spacing(2),
    backgroundColor: darkBlue,
    fontFamily: "Oswald",
  },
  "conteiner-margin": {
    margin: theme.spacing(2),
  },
  "container-special": {
    backgroundColor: darkBlue,
    paddingBotton: 10,
  },
  "container-principal": {
    backgroundColor: lightGray,
  },
  marginButton: {
    margin: theme.spacing(2),
    padding: 12,
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  control: {
    padding: theme.spacing(2),
  },
  gridList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const App = () => {
  const colsNumber = () => {
    if (window.innerWidth > 600) {
      return 4;
    }
    return 2;
  };

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [nombre, setNombre] = useState();
  const [apellido, setApellido] = useState();
  const [mail, setMail] = useState();
  const [edad, setEdad] = useState();
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeNombre = (e) => {
    setNombre(e.target.value);
  };

  const handleChangeApellido = (e) => {
    setApellido(e.target.value);
  };

  const handleChangeMail = (e) => {
    setMail(e.target.value.replace(" ", "").trim());
  };

  const handleChangeEdad = (e) => {
    setEdad(e.target.value);
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value);
  };

  const handleChangeCountry = (event) => {
    setCountry(event.target.value);
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!nombre) {
      formIsValid = false;
      setError(true);
    }

    if (!apellido) {
      formIsValid = false;
      setError(true);
    }

    if (!mail) {
      formIsValid = false;
      setError(true);
    }

    if (!edad) {
      formIsValid = false;
      setError(true);
    }

    if (!city) {
      formIsValid = false;
      setError(true);
    }
    if (!country) {
      formIsValid = false;
      setError(true);
    }

    // if (typeof fields["name"] !== "undefined") {
    //   if (!fields["name"].match(/^[a-zA-Z]+$/)) {
    //     formIsValid = false;
    //     errors["name"] = "Only letters";
    //   }
    // }

    // //Email
    // if (!fields["email"]) {
    //   formIsValid = false;
    //   errors["email"] = "Cannot be empty";
    // }

    // if (typeof fields["email"] !== "undefined") {
    //   let lastAtPos = fields["email"].lastIndexOf("@");
    //   let lastDotPos = fields["email"].lastIndexOf(".");

    //   if (
    //     !(
    //       lastAtPos < lastDotPos &&
    //       lastAtPos > 0 &&
    //       fields["email"].indexOf("@@") == -1 &&
    //       lastDotPos > 2 &&
    //       fields["email"].length - lastDotPos > 2
    //     )
    //   ) {
    //     formIsValid = false;
    //     errors["email"] = "Email is not valid";
    //   }
    // }

    // this.setState({ errors: errors });
    return formIsValid;
  };
  const sendEmail = () => {
    const tokenEmail =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImZlc3RpdmFsIGRlIGpheiIsImlhdCI6MTUxNjIzOTAyMn0.G2-CJ4tnY8uTbXpAAj2-H59Z0S2Z5OWFMb6awCSNOk8";
    const headers = {
      "Content-Type": "application/json",
      Authorization: `${tokenEmail}`,
    };
    const payload = {
      type: "VIV",
      name: `${nombre} ${apellido}`,
      recipient: mail,
      register: {
        nombre,
        apellido,
        mail,
        edad,
        city,
        country,
      },
    };
    axios
      .post(`${hostEmail}`, payload, {
        headers: headers,
      })
      .then((resp) => {
        console.log(resp.data);
      })
      .catch((error) => {
        console.log("Error => ", error.message);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    try {
      if (handleValidation()) {
        sendEmail();
        setNombre("");
        setApellido("");
        setMail("");
        setEdad("");
        setCity("");
        setCountry("");
        setOpen(true);
      } else {
      }
    } catch (error) {
      setError(true);
    }
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">Felicidades</h2>
      <p id="simple-modal-description">Te hemos enviado un correo</p>
    </div>
  );

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <div
          className={[classes["container-special"], "conteiner1-botton"].join(
            " "
          )}
        >
          <Grid
            container
            className={classes}
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={5}>
              <Grid
                container
                direction="row-reverse"
                justify="flex-start"
                alignItems="flex-start"
              >
                <img
                  src={logo}
                  className={classes.logo}
                  height={180}
                  alt="logo"
                ></img>
              </Grid>
              <Spacer space={"1"}></Spacer>
              <Grid item xs={12} className={classes}>
                <TrumpetTitle
                  title=" ENCUENTROS EN VIVO "
                  color={lightGray}
                ></TrumpetTitle>
                <Typography
                  align="right"
                  className={[
                    classes["conteiner-margin"],
                    classes["font-size"],
                  ].join(" ")}
                >
                  Laboratorio experimental y creativo por primera vez en online.
                </Typography>
                <Typography
                  align="right"
                  className={[
                    classes["conteiner-margin"],
                    classes["font-size"],
                  ].join(" ")}
                >
                  Artistas Chilenos y europeos co-creando obras inéditas que fusionan vanguardia, improvisación y herramientas tecnológicas, todo a distancia
                </Typography>
                <Spacer space={"5"}></Spacer>
                <GridList
                  className={[
                    classes.gridList,
                    classes["conteiner-margin"],
                  ].join(" ")}
                  cols={colsNumber()}
                  cellHeight={160}
                >
                  {tileData.map((tile, index) => (
                    <GridListTile key={index} cols={tile.cols || 2}>
                      <img src={tile.img} alt={tile.title} />
                      <GridListTileBar
                        title={tile.title}
                        subtitle={tile.author}
                        classes={{
                          root: classes.titleBar,
                          title: classes.title,
                        }}
                      />
                    </GridListTile>
                  ))}
                </GridList>
              </Grid>
              <Spacer space={"5"}></Spacer>
              <Card
                className={[
                  classes.root,
                  classes["container-principal"],
                  classes["conteiner-margin"],
                ].join(" ")}
              >
                <Spacer space={"5"}></Spacer>

                <Grid item xs={12} className={classes}>
                  <FormControl
                    autoComplete="off"
                    noValidate
                    fullWidth={true}
                    onSubmit={handleSubmit}
                  >
                    <TextField
                      id="nombre"
                      value={nombre}
                      onChange={handleChangeNombre}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Nombre
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                    <TextField
                      id="apellido"
                      value={apellido}
                      onChange={handleChangeApellido}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Apellido
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                    <TextField
                      id="mail"
                      value={mail}
                      onChange={handleChangeMail}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Mail</InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                    <TextField
                      id="edad"
                      type="number"
                      value={edad}
                      onChange={handleChangeEdad}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Edad</InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                    <Select
                      id="country"
                      value={country}
                      onChange={handleChangeCountry}
                      displayEmpty
                      variant="outlined"
                      className={[classes.selectEmpty].join(" ")}
                    >
                      <MenuItem value="">
                        <em>País</em>
                      </MenuItem>
                      {countries.map((pais, index) => {
                        return (
                          <MenuItem key={index} value={pais.name}>
                            {pais.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <TextField
                      id="city"
                      value={city}
                      onChange={handleChangeCity}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Ciudad
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                    <Spacer space={"1"}></Spacer>
                    {error ? (
                      <div className="message-error">
                        <FormHelperText>Favor llenar formulario</FormHelperText>
                      </div>
                    ) : null}
                    <Button
                      type="button"
                      onClick={handleSubmit}
                      className={classes.marginButton}
                      variant="contained"
                      color="primary"
                    >
                      Registrarme
                    </Button>
                  </FormControl>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    {body}
                  </Modal>
                </Grid>
              </Card>
              <Spacer space="15"></Spacer>
            </Grid>
          </Grid>
        </div>
      </ThemeProvider>
    </div>
  );
};

export default App;
